// Onboarding macro-target sequencing helpers.
//
// Pre-launch safety rule (auto onboarding target mode):
// The onboarding body/profile screen (MacroQuiz) only COLLECTS profile info.
// It must NEVER persist auto_macros_enabled=true. Auto Macros is turned on
// ONLY by a successful backend POST /profile/regenerate-targets, atomically
// with the generated targets. This prevents a split-brain account marked
// Auto=true with no (or stale) targets when regeneration fails.
//
// Extracted as a pure, dependency-free module so the sequencing contract can be
// unit-tested with plain Node (see src/__tests__/onboardingMacros.node.test.js).

/**
 * Build the preliminary profile payload the onboarding screen persists.
 * Regardless of manual vs automatic mode, auto_macros_enabled is FORCED to
 * false here — the flag is never flipped true from this screen.
 */
export function buildOnboardingProfileData(base) {
  return { ...base, auto_macros_enabled: false };
}

/**
 * Automatic mode network sequence for an authenticated (non-demo) account:
 *   1. persist the preliminary profile (auto_macros_enabled must be false)
 *   2. regenerate targets on the backend (this is the SOLE transition to
 *      auto_macros_enabled=true, written atomically with the targets)
 *
 * If step 2 rejects, the error propagates to the caller and NOTHING here has
 * marked the account Auto=true — the persisted state remains false. The caller
 * is expected to stay on the screen and let the user retry.
 *
 * @throws whatever saveProfile/regenerateTargets throw (never swallowed)
 * @returns the regenerateTargets() response
 */
export async function runAutomaticMacroSetup({ profileData, saveProfile, regenerateTargets }) {
  if (profileData?.auto_macros_enabled === true) {
    // Defensive: the preliminary save must never carry Auto=true.
    throw new Error('preliminary profile save must not enable auto macros');
  }
  await saveProfile(profileData);
  return await regenerateTargets();
}
